import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'

import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { FORECAST_LIST_PATH } from '~const/index'

import { UserFacade } from '../features'

@Injectable({
  providedIn: 'root',
})
export class UserGuard implements CanActivate {
  private readonly router = inject(Router)

  private readonly userFacade = inject(UserFacade)

  constructor() {}

  canActivate(): Observable<boolean> | boolean {
    return this.userFacade.user$.pipe(
      map(user => {
        if (user) {
          this.router.navigateByUrl(`/${FORECAST_LIST_PATH}`)

          return false
        }

        return true
      })
    )
  }
}
